import type {Element, Nodes} from 'hast'
import {find, html} from 'property-information'

import {delimiterProperty} from './extensions/delimiters'

export function isTag<T extends keyof HTMLElementTagNameMap>(node: Nodes, tagName: T): node is Element & {tagName: T} {
  return node.type === 'element' && node.tagName === tagName
}

/**
 * Convert hast element `properties` object to an object keyed by the HTML attribute name (eg, `class` rather than
 * `className`).
 */
export function hastPropertiesToHtmlAttributes(properties: Element['properties']) {
  if (!properties) return {}

  const result: Record<string, unknown> = {}
  for (const property of Object.getOwnPropertyNames(properties)) {
    const info = find(html, property)
    result[info.attribute] = properties[property]
  }
  return result
}

/** Extract the concatenated non-delimiter text nodes from an element */
export function getTextContent(node: Element): string {
  return node.children
    .map(child =>
      child.type === 'text'
        ? child.value
        : // No idea why `delimiterProperty in child.properties` wasn't working, but this works fine so I guess it's good
          child.type === 'element' && !Object.hasOwn(child.properties ?? {}, delimiterProperty)
          ? getTextContent(child)
          : '',
    )
    .join('')
}
